module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/equalizer-0fb8882162311258292cb184c8028b4d.svg";